import $ from 'jquery'

const NUMBER_INPUT = 'input[type="number"]'
const BLOCKED_KEYS = ['e', 'E']
const BLOCKED_CHARS = /[eE]/

export const initNumberInputs = () => {
    $(document).on('keydown', NUMBER_INPUT, (e) => {
        BLOCKED_KEYS.includes(e.key) && e.preventDefault()
    })

    $(document).on('paste', NUMBER_INPUT, (e) => {
        const pasted = e.originalEvent?.clipboardData?.getData('text') ?? ''

        BLOCKED_CHARS.test(pasted) && e.preventDefault()
    })
}
